import { useState, useEffect } from 'react'
import { fetchProjects, type GhostPost } from '../ghost'

interface UseGhostProjectsResult {
	projects: GhostPost[]
	loading: boolean
	error: string | null
}

export function useGhostProjects(): UseGhostProjectsResult {
	const [projects, setProjects] = useState<GhostPost[]>([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState<string | null>(null)

	useEffect(() => {
		fetchProjects()
			.then((data) => {
				setProjects(data)
				setLoading(false)
			})
			.catch((err: Error) => {
				setError(err.message)
				setLoading(false)
			})
	}, [])

	return { projects, loading, error }
}
